import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { IdentityClientService, IdentityCommonService, IdentityUserService } from '@auth';
import { StorageService } from '@core';

const SIGN_IN_ROUTE = 'signIn';
const AUTH_NOT_LOGGED_ROUTES: string[] = ['signIn', 'signup', 'forgot-password', 'reset-password'];
const AUTO_LOGIN_ROUTE = 'embedded';
const CONFIG_SERVICE_STORAGE_KEY = 'configurator-cs';
const CONFIGURE_SERVICE_ROUTE = 'configure-service';
const ADMIN_ROLE = 'ADMINISTRATOR';

export const authGuard: CanActivateFn = (route, state) => {
    const identityCommonService = inject(IdentityCommonService);
    const identityUserService = inject(IdentityUserService);
    const router = inject(Router);
    const storageService = inject(StorageService);

    const configTree = storageService.get(CONFIG_SERVICE_STORAGE_KEY);
    const user = identityUserService.getUser();

    if (configTree && !route.routeConfig?.path?.includes(CONFIGURE_SERVICE_ROUTE)) {
        storageService.remove(CONFIG_SERVICE_STORAGE_KEY);
    }

    if (AUTH_NOT_LOGGED_ROUTES.includes(route.url[0].path) && !identityCommonService.isLogged()) {
        return true;
    }
    else if (state.url.includes(AUTO_LOGIN_ROUTE) && !identityCommonService.isLogged()) {
        const token = route.queryParams['token'];

        if (token !== undefined) {
            return new Promise((resolve) => {
                identityCommonService.autologin(token).then((response) => {
                    resolve(response);
                }).catch(() => {
                    resolve(false);
                });
            })
        }
        else {
            return false;
        }
    }
    else if (
        !AUTH_NOT_LOGGED_ROUTES.includes(route.url[0].path) &&
        identityCommonService.isLogged() && user.role === ADMIN_ROLE &&
        route.data['isAdminDetails']
    ) {
        return true;
    }
    else if (
        !AUTH_NOT_LOGGED_ROUTES.includes(route.url[0].path) &&
        identityCommonService.isLogged() && user.role === ADMIN_ROLE &&
        route.data['isOfficerAccountDetails']
    ) {
        return true;
    }
    else if (!AUTH_NOT_LOGGED_ROUTES.includes(route.url[0].path) && identityCommonService.isLogged()) {
        return true;
    }
    else {
        const clientUrl = inject(IdentityClientService).get().url;
        const target = identityCommonService.isLogged() ? identityCommonService.getModuleHomePath() : SIGN_IN_ROUTE;

        router.navigate([`/${clientUrl}/${target}`]);
        return false;
    }
};
